import { defineStore } from "pinia";
import Services from '@/services/sutting/skillsServices'
import { mapList, mapSkill } from '@/helpers/mapFuncs'

export const useSkillsStore = defineStore("skills", {
persist: true,
state:()=>({
    skill: {},
    skills: [],
}),
getters : {
    getSkill() {
        return mapSkill(this.skill)
    },
    getSkills() {
        return this.skills.map(mapSkill)
    },
    getSkillsList() {
        return this.skills.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setSkill(skill) {
        this.skill = skill
    },
    setSkills(skills) {
        this.skills = skills
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setSkill(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setSkills(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.skills.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.skills[this.skills.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.skills = this.skills.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
